<template>
  <v-container>
    <Loader v-if="isLoading" />
    <b-table
      v-else-if="!isLoading"
      :data="nodes"
      class="table"
      v-bind:mobileCards="false"
    >
      <template slot-scope="props">
          <b-table-column field="id" label="Name">
          <router-link
            class="router-link"
            :to="{ name: 'node', params: {address: props.row.owner_address}}"
          >
            {{ props.row.description.name ? props.row.description.name : 'View Node' }}
          </router-link>
          </b-table-column>

          <b-table-column field="voting_power" label="Voting Power">
            {{ props.row.voting_power }}
          </b-table-column>

          <b-table-column field="rank" label="Rank">
            {{ props.row.rank && props.row.rank > 23 ? '' : props.row.rank + 1 }}
          </b-table-column>

          <b-table-column field="owner_address" label="Owner Address">
            <router-link class="router-link short-addr" :to="{ name: 'address', params: {address: props.row.owner_address}}">
              {{ props.row.owner_address }}
            </router-link>
          </b-table-column>

          <b-table-column field="verify" label="Verified">
            {{ props.row.verified }}
          </b-table-column>

          <b-table-column field="status" label="State">
            {{ props.row.state }}
          </b-table-column>

          <b-table-column field="location" label="Location">
            {{ props.row.description.location ? props.row.description.location : 'N/A'}}
          </b-table-column>

          <b-table-column field="shares" label="Total Stakes">
            {{
              parseFloat(props.row.shares).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })
            }}
          </b-table-column>

          <b-table-column field="compensation" label="Compensation">
            {{ props.row.comp_rate | convertFraction() }}
          </b-table-column>
      </template>
    </b-table>

    <v-dialog
      :value="calculator"
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title style="justify-content:space-between;">
          <span class="headline">Award Calculator</span>
          <span style="font-size:200%; cursor:pointer;" @click="$store.dispatch('setCalculator', false)">&times;</span>
        </v-card-title>
        <v-card-text>
          <v-container style="width: 100%">
            <v-layout wrap>
              <v-flex xs12 style="text-align:left;">
                Total Stakes: {{ totalShares }}
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Stake Amount" required v-model="calStakeAmount" v-on:keydown.enter="calAward"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="mappedNodes"
                  item-text="name"
                  item-value="index"
                  label="Stake To (Validator)"
                  required
                  v-model="calStakeTo"
                ></v-select>
              </v-flex>
              <v-flex xs12 style="text-align:left;" v-if="caledAward != null">
                <div>
                  <p>Your yearly award will be:</p>
                  <ul style="list-style-type: disc; list-style-position: inside;">
                    <li>{{ caledAward }} CMTs, if stake with CMT Cube (Annual interest rate {{ (caledAward / staticStakeAmount * 100).toFixed(2) }}%)</li>
                    <li>{{ caledAward * 0.8 }} CMTs, if stake with CMT Wallet App (Annual interest rate {{ (caledAward * 0.8 / staticStakeAmount * 100).toFixed(2) }}%)</li>
                  </ul>
                </div>
                <div style="color:gray; margin-top: 0.5em;">
                  <p>*This is only an estimated amount based on</p>
                  <ol style="list-style-position: inside;">
                    <li>current estimated yearly block count ({{BlockCount}} blocks)</li>
                    <li>current award status ({{BlockAward}} CMTs for each block)</li>
                  </ol>
                  <p>Subject to change.</p>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="calAward">Calculate</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '../reusables/loader.vue';

export default {
  name: 'Nodes',
  data() {
    return {
      isLoading: false,
      calStakeAmount: null,
      staticStakeAmount: null,
      calStakeTo: null,
      caledAward: null,
      BlockAward: null,
      BlockCount: 2814000,
    };
  },
  components: {
    Loader,
  },
  filters: {
    convertFraction(value) {
      const split = value.split('/');
      const decimal = parseInt(split[0], 10) / parseInt(split[1], 10);
      const percentage = decimal * 100;
      return value.indexOf('/') > -1 ? `${percentage.toFixed(2)}%` : value;
    },
  },
  watch: {
    nodes() {
      this.isLoading = false;
    },
  },
  computed: {
    ...mapGetters(['nodes', 'loader', 'blocks', 'calculator']),
    mappedNodes() {
      return this.nodes.filter(n => n.active === 'Y' && n.state === 'Validator').map((n, i) => ({ name: n.description.name || `${n.owner_address.substring(0, 20)}...`, index: i }));
    },
    totalShares() {
      let t = 0;
      for (let i = 0; i < this.nodes.length; i++) {
        const n = this.nodes[i];
        if (n.active === 'Y' && (n.state === 'Validator' || n.state === 'Backup Validator')) {
          t += parseFloat(n.shares);
        }
      }
      return t.toFixed(2);
    },
  },
  created() {
    this.$store.dispatch('fetchNodes');
    this.$store.dispatch('fetchBlocks', {
      limit: 1,
      page: 1,
    });
  },
  methods: {
    calAward() {
      if (!this.calStakeAmount || isNaN(this.calStakeAmount) ||
        this.calStakeTo === null) {
        return;
      }
      if (!this.blocks || this.blocks.length === 0) {
        return;
      }

      const sa = parseFloat(this.calStakeAmount);

      if (sa < 1000) {
        this.caledAward = 0;
        return;
      }

      this.staticStakeAmount = sa;

      const sv = this.nodes[this.calStakeTo];

      this.BlockAward = this.blocks[0].rewards_total;

      if (!this.BlockAward) {
        window.location.reload();
        return;
      }

      let totalPower = 0;
      for (let i = 0; i < this.nodes.length; i++) {
        totalPower += parseInt(this.nodes[i].voting_power, 10);
      }
      let powerProp;
      if ((sa + parseFloat(sv.shares)) / (sa + parseFloat(this.totalShares)) > 0.12) {
        powerProp = 0.12;
      } else {
        powerProp = (parseInt(sv.voting_power, 10) + sa) / (totalPower + sa);
      }

      const cr = sv.comp_rate.split('/');
      if (cr.length !== 2) {
        this.caledAward = 0;
        return;
      }

      const award =
        sa / (sa + parseFloat(sv.shares)) *
        (parseInt(cr[1], 10) - parseInt(cr[0], 10)) / parseInt(cr[1], 10) *
        powerProp *
        this.BlockAward;

      this.caledAward = award * this.BlockCount;
    },
  },
};
</script>

